import { GroupWorkoutHit } from 'interfaces/group-workout'

export const getGroupWorkoutHitKey = (hit: GroupWorkoutHit) => {
  const bagId = hit.bag?.id
  const hasStableHitFingerprint = bagId && hit.punchedAt && hit.force !== undefined && hit.force !== null

  if (hasStableHitFingerprint) {
    return `hit:${bagId}:${hit.punchedAt}:${hit.force}`
  }

  const hitId = (hit as { id?: string }).id
  if (hitId) {
    return `id:${hitId}`
  }

  return `fallback:${JSON.stringify(hit)}`
}

export const mergeGroupWorkoutHits = (
  currentHits: GroupWorkoutHit[],
  incomingHits: GroupWorkoutHit[],
) => {
  if (incomingHits.length === 0) return currentHits
  if (currentHits.length === 0) return incomingHits

  const seenHitKeys = new Set(currentHits.map(getGroupWorkoutHitKey))
  const mergedHits = [...currentHits]

  for (const hit of incomingHits) {
    const hitKey = getGroupWorkoutHitKey(hit)
    if (!seenHitKeys.has(hitKey)) {
      seenHitKeys.add(hitKey)
      mergedHits.push(hit)
    }
  }

  return mergedHits
}
